module.exports = __webpack_public_path__ + "static/media/whiteQuote.74a8a5c2.svg";